import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaPhoneAlt, FaCalendarAlt } from "react-icons/fa";

const Navbar = ({ isScrolled = false }) => {
  const hotel = useSelector((state) => state.hotel.data) || {};
  const hotelName = hotel.name || "Ganesh Holiday Homes";
  const hotelPhone = hotel.phone || "+91 9673150591";
  const cleanPhone = hotelPhone.replace(/[^0-9]/g, "");
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-custom sticky-top ${
        isScrolled ? "navbar-scrolled" : ""
      }`}
    >
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          {hotel.logoUrl ? (
            <img
              src={hotel.logoUrl}
              alt={hotelName}
              className="brand-logo-img"
            />
          ) : (
            <div
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                background: "linear-gradient(135deg, #ff4757, #ff6b6b)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              G
            </div>
          )}
          <div className="d-flex flex-column">
            <span className="brand-title">{hotelName}</span>
            <span className="brand-subtitle">Beachside Homestay • Shrivardhan</span>
          </div>
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler border-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#globalNavLinks"
          aria-controls="globalNavLinks"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Nav Menu */}
        <div className="collapse navbar-collapse" id="globalNavLinks">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0 align-items-lg-center">
            <li className="nav-item">
              <Link
                className={`nav-link-custom ${pathname === "/" ? "fw-bold text-danger" : ""}`}
                to="/"
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link-custom ${pathname === "/rooms" ? "fw-bold text-danger" : ""}`}
                to="/rooms"
              >
                Rooms & Tariffs
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link-custom ${pathname === "/about-us" || pathname === "/about" ? "fw-bold text-danger" : ""}`}
                to="/about-us"
              >
                About Us
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link-custom ${pathname === "/contact-us" || pathname === "/contact" ? "fw-bold text-danger" : ""}`}
                to="/contact-us"
              >
                Contact & Location
              </Link>
            </li>
            <li className="nav-item">
              <a className="nav-link-custom" href="/#faq">
                FAQ
              </a>
            </li>
          </ul>

          <div className="d-flex align-items-center gap-3">
            <a href={`tel:${cleanPhone}`} className="nav-phone-btn d-none d-xl-flex">
              <FaPhoneAlt className="text-danger" />
              <span>{hotelPhone}</span>
            </a>
            <Link to="/booking" className="btn-luxury-primary">
              <FaCalendarAlt />
              <span>Book Now</span>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
